module.exports = __webpack_public_path__ + "static/mindmelogo-poweteam-a3fb344a0c93be3178e930cfed729b8d.png";